module.exports = __webpack_public_path__ + "img/img2.3f052136.png";